export const selectCustomerServicesByCustomer = (state, customerId) =>
  state.customerServices && state.customerServices.servicesByCustomer
    ? state.customerServices.servicesByCustomer[customerId] || []
    : [];

export const selectCustomerServicesLoading = (state) =>
  state.customerServices ? state.customerServices.loading : 'idle';

export const selectCustomerServicesError = (state) =>
  state.customerServices ? state.customerServices.error : null;
